import React, { useState, useEffect, Fragment } from "react";
import { connect } from "react-redux";
import {
  Modal,
  ModalHeader,
  ModalFooter,
  ModalBody,
  Button,
  FormGroup,
  Input,
  Label,
  Col,
  Container,
  Row,
  Spinner,
} from "reactstrap";
// import { FileUploader } from "react-drag-drop-files";
import Dropzone from "react-dropzone";
import {
  uploadWorksheet,
  addWorksheetLink,
} from "../../../../actions/feedActions";
import "../uploadWorksheet/addworksheet.scss";
import { uploadVideoinTopics } from "../../../../actions/tutorFeedActions";

function UploadVideo(props) {
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);

  const [fileLabel, setfileLabel] = useState("");
  const [fileSource, setfileSource] = useState("");
  const [worksheetFileData, setworksheetFileData] = useState([]);
  const [worksheetFileName, setworksheetFileName] = useState("");
  const [fileExts, setfileExts] = useState([
    "pdf",
    "doc",
    "docx",
    "xls",
    "xlsx",
    "ppt",
    "pptx",
    "gif",
    "jpg",
    "png",
    "jpeg",
  ]);
  const [fileLoader, setfileLoader] = useState(false);
  const [linkLoader, setlinkLoader] = useState(false);

  const [addLink, setaddLink] = useState("");
  const [addLinkSource, setaddLinkSource] = useState("");
  const [sourceEmail, setsourceEmail] = useState("");
  const [linkLabel, setlinkLabel] = useState("");
  const [videoName, setvideoName] = useState("");
  const [videoUrl, setvideoUrl] = useState("");
  const [agreeCheckBox1, setagreeCheckBox1] = useState(false);

  console.log("Here are the props:", props);

  const {
    assementId,
    testId,
    teacherId,
    worksheetFiles,
    worksheetUrls,
    color = false,
  } = props;
  return (
    <React.Fragment>
      <Modal isOpen={props.open} centered size="md" backdrop={true}>
        <ModalHeader toggle={() => props.toggleVideoModal()}>
          Add new Video
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col sm="12">
              <FormGroup>
                <label className="mt-2">Give this video a name:</label>
                <Input
                  className="form-control form-control-sm"
                  type="text"
                  value={videoName}
                  placeholder=""
                  onChange={(event) => {
                    setvideoName(event.target.value);
                  }}
                />
              </FormGroup>
              <FormGroup>
                <label className="mt-2">Paste video link:</label>
                <Input
                  className="form-control form-control-sm"
                  type="text"
                  value={videoUrl}
                  placeholder=""
                  onChange={(event) => {
                    setvideoUrl(event.target.value);
                  }}
                />

                <div class="form-check mt-5">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    onClick={(e) => setagreeCheckBox1(e.target.checked)}
                    value={agreeCheckBox1}
                  />
                  <label class="form-check-label" style={{ fontSize: "15px" }}>
                    I certify that this is a free resource (no
                    copyright infringement)
                  </label>
                </div>
              </FormGroup>
            </Col>

            <Col sm="12">
              <button
                disabled={agreeCheckBox1 ? false : true}
                className="btn btn-success btn-block"
                style={{ marginTop: "9%", width: "100%" }}
                onClick={() => {
                  props
                    .uploadVideoinTopics(
                      assementId,
                      testId,
                      videoName,
                      videoUrl,
                      teacherId,
                      0
                    )
                    .then((res) => {
                      window.location.reload();
                      debugger;
                    })
                    .catch((err) => {
                      debugger;
                    });
                }}
              >
                {linkLoader == true ? (
                  <Spinner size="sm" style={{ marginRight: "5px" }} />
                ) : null}
                Submit
              </button>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter></ModalFooter>
      </Modal>
    </React.Fragment>

    // </Container>
  );
}
function mapStateToProps(state) {
  return {};
}
export default connect(mapStateToProps, { uploadVideoinTopics })(UploadVideo);
